import React from "react";
import styled from "styled-components";

import { COLORS } from "../../../../../constants";

const StyledHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.black85};
`;

interface ModalHeaderProps {
  children: React.ReactNode;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ children }) => (
  <StyledHeader>{children}</StyledHeader>
);
